module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-block",
    class: _vm.classeBotaoUnificado,
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.loading
    },
    on: {
      "click": _vm.onClickUnificado
    }
  }, [_c('i', {
    staticClass: "fa m-r-sm",
    class: _vm.iconeBotaoUnificado
  }), _vm._v("\n    " + _vm._s(_vm.labelBotaoUnificado) + "\n  ")]), _vm._v(" "), (_vm.arquivoUnificadoGrv) ? _c('button', {
    staticClass: "btn btn-danger btn-block m-t-xs",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.loading
    },
    on: {
      "click": _vm.deleteUnificado
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o m-r-xs"
  }), _vm._v("\n    Excluir documento\n  ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "uploadUnificarGrv",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": "application/pdf,image/jpeg,image/png,.pdf,.jpg,.jpeg,.png"
    },
    on: {
      "change": _vm.uploadUnificado
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a905e45","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/grv-patio/BtnUploadArquivoGrv.vue
// module id = 1835
// module chunks = 18